import type { WidgetId } from '@omnia/shared';
import type { InfoWidget } from './widgets/types.ts';
import { WeatherWidget } from './widgets/WeatherWidget.tsx';
import { MarketsWidget } from './widgets/MarketsWidget.tsx';
import { NetWorthWidget } from './widgets/NetWorthWidget.tsx';
import { BellWidget } from './widgets/BellWidget.tsx';

/**
 * Adding a widget: write its component under widgets/, add its id to WIDGET_IDS in
 * packages/shared/src/widgets.ts (settings and the label in i18n follow from it) and add one entry here.
 *  */
export const INFO_WIDGETS: readonly InfoWidget[] = [
  { id: 'weather', zone: 'main', Bar: WeatherWidget },
  { id: 'markets', zone: 'main', Bar: MarketsWidget },
  { id: 'netWorth', zone: 'main', Bar: NetWorthWidget },
  { id: 'bell', zone: 'end', Bar: BellWidget },
];

export const enabledWidgets = (widgets: Partial<Record<WidgetId, boolean>>, zone: InfoWidget['zone']) =>
  INFO_WIDGETS.filter((widget) => widget.zone === zone && widgets[widget.id] !== false);
